// @ts-strict-ignore
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewChild,
} from '@angular/core';
import { SohoBusyIndicatorDirective } from 'ids-enterprise-ng';
import { SohoSwapListComponent } from 'ids-enterprise-ng';
import { LMCreateReportDialogService } from '@report/index';

@Component({
  selector: 'lm-create-report-fields-dialog',
  templateUrl: './lm-create-report-fields-dialog.component.html',
  styleUrls: ['./lm-create-report-fields-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  })
export class LMCreateReportFieldsDialogComponent implements AfterViewInit {

  constructor(
    private lmCreateReportDialogService: LMCreateReportDialogService
  ) {}

  @ViewChild(SohoBusyIndicatorDirective, { static: false })
  busyIndicator: SohoBusyIndicatorDirective;
  @ViewChild(SohoSwapListComponent, { static: false })
  swaplist: SohoSwapListComponent;

  @Input() businessClass: string;
  @Input() listName: string;
  @Input() userFolderId: string;
  @Input() createReportUrl: string;
  @Input() reportType: LMReportType;

  lookupUrl: string;

  searchOptions = {
    name: '',
    filterType: 'contains',
    fieldType: [],
  };

  fieldsAutomationId = [{ name: 'data-automation-id', value: 'lm-create-report-fields'}];
  typeSearchAutomationId = [{ name: 'data-automation-id', value: 'lm-create-report-type-search'}];

  comparators = [
    {
      value: 'contains',
      text: Soho.Locale.translate('Contains'),
      icon: 'filter-contains',
    },
    {
      value: 'startsWith',
      text: Soho.Locale.translate('StartsWith'),
      icon: 'filter-start-with',
    },
    {
      value: 'endsWith',
      text: Soho.Locale.translate('EndsWith'),
      icon: 'filter-end-with',
    },
    {
      value: 'equals',
      text: Soho.Locale.translate('Equals'),
      icon: 'filter-equals',
    },
  ];

  fieldTypes = [
    {
      value: 'TEXT',
      label: Soho.Locale.translate('FieldPicker_text_type_label'),
    },
    {
      value: 'BOOLEAN',
      label: Soho.Locale.translate('FieldPicker_boolean_type_label'),
    },
    {
      value: 'NUMBER',
      label: Soho.Locale.translate('FieldPicker_number_type_label'),
    },
    {
      value: 'DATE',
      label: Soho.Locale.translate('FieldPicker_date_type_label'),
    },
    {
      value: 'BINARY',
      label: Soho.Locale.translate('FieldPicker_binary_type_label'),
    },
    {
      value: 'KEY',
      label: Soho.Locale.translate('FieldPicker_keyfield_type_label'),
    },
    {
      value: 'USERFIELDS',
      label: Soho.Locale.translate('FieldPicker_userfield_type_label'),
    },
  ];

  ngAfterViewInit(): void {
    this.lmCreateReportDialogService
      .loadData()
      .subscribe((displayFields: Array<any>) => {
        this.lmCreateReportDialogService.rawFields = displayFields;
        if (this.reportType !== 'ReportFromScratch') {
          this.swaplist.availableItems = [];
          this.swaplist.selectedItems = displayFields;
        } else {
          this.swaplist.availableItems = displayFields;
          this.swaplist.selectedItems = [];
        }
        this.lmCreateReportDialogService.selectedItems =
          this.swaplist.selectedItems;
      });
  }

  updateItems() {
    this.lmCreateReportDialogService.selectedItems =
      this.swaplist.selectedItems;
  }

  onFieldTypeSelected() {
    this.runSearch();
  }

  onNameEntered(event) {
    this.runSearch();
    event.stopPropagation();
    event.preventDefault();
  }

  onComparatorChange(event: SohoFieldFilteredEvent) {
    this.searchOptions.filterType = event?.filterOption?.value;
    this.runSearch();
  }

  private runSearch() {
    const selectedFields = this.lmCreateReportDialogService.selectedItems.map(
      (field) => field.text
    );

    this.swaplist.availableItems = this.lmCreateReportDialogService.rawFields
      .filter((field) => {
        if (selectedFields.includes(field.name)) {
          return false;
        }

        if (
          selectedFields.includes(field.name) &&
          !this.nameFound(
            this.searchOptions.filterType,
            this.searchOptions.name.toLowerCase(),
            field.name.toLowerCase()
          )
        ) {
          return false;
        }

        if (
          this.searchOptions.name &&
          !this.nameFound(
            this.searchOptions.filterType,
            this.searchOptions.name.toLowerCase(),
            field.name.toLowerCase()
          )
        ) {
          return false;
        }

        if (
          this.searchOptions.fieldType.length > 0 &&
          !this.searchOptions.fieldType.includes(field.fieldType)
        ) {
          return false;
        }

        return true;
      })
      .map((field, index) => ({
        ...field,
        id: index,
        value: field.name,
        text: field.name,
      }));

    this.swaplist.selectedItems =
      this.lmCreateReportDialogService.selectedItems;
  }

  private nameFound(filterType: string, name: string, fieldName: string) {
    if (filterType === 'equals') {
      return fieldName === name;
    } else if (filterType === 'startsWith') {
      return fieldName.startsWith(name);
    } else if (filterType === 'endsWith') {
      return fieldName.endsWith(name);
    }

    return fieldName.indexOf(name) > -1;
  }
}
